// extracted by mini-css-extract-plugin
export default {"sidebarSectionsLoadingContainer":"SidebarSectionsLoading-module__sidebarSectionsLoadingContainer__h6FH0wm"};